import { render, staticRenderFns } from "./AssetInformationPreviewModal.vue?vue&type=template&id=60b47a5d&scoped=true&"
import script from "./AssetInformationPreviewModal.vue?vue&type=script&lang=js&"
export * from "./AssetInformationPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./AssetInformationPreviewModal.vue?vue&type=style&index=0&id=60b47a5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b47a5d",
  null
  
)

export default component.exports